import React, { useState } from 'react';
import Button from '@material-ui/core/Button';
// import CircularProgress from '@material-ui/core/CircularProgress';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
// import useLoginMutation from '../../graphql/mutations/login'
import { DEFAULT_LOGIN } from '../../utils/constants';

const useStyles = makeStyles(theme => ({
    form: {
      width: '100%', // Fix IE 11 issue.
      marginTop: theme.spacing(1),
    },
    submit: {
      margin: theme.spacing(3, 0, 2),
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1),
    },
    error: {
        color: '#9e1c1c',
        marginTop: theme.spacing(3)
    },
    progress: {
        color: '#fff',
    }
}));

const LoginForm = ({router}) => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    // const [completed, setCompleted] = useState(false);
    // const mounted = React.useRef();

    
    const [errorMessage, setErrorMessage] = useState(null);
    const classes = useStyles();
    // const handleError = ({ graphQLErrors }) => {
    //   if (!graphQLErrors) return;
    //   const error = graphQLErrors[0].message;
    //   if( error === "security_exception") setErrorMessage('Incorrect email or password');
    // }
    // const login = useLoginMutation({ skip: !loading, variables: {email, password}, onCompleted: () => setCompleted(true)});
    
    // const [ login, { loading, data } ] = useLoginMutation({ onError: handleError, onCompleted: () => setCompleted(true)});
    
    // temporary solution till the next release of apollo client to support promised useLazyQuery
    // React.useEffect(() => {
    //     if (!mounted.current) {
    //       mounted.current = true;
    //     } else {
    //         if (data) {
    //             localStorage.setItem("token", data.login.token);
    //             localStorage.setItem("expiresAt", data.login.expires);
    //             localStorage.setItem("connectedTime", new Date().getTime());
    //             localStorage.setItem("expiresToken2", new Date().getTime());

    //             if (completed) router.push("/");
    //         }
    //     }
    // }, [completed, data, router]);

    const submit = event => {
        event.preventDefault();
        // login({ email, password });
        if (email === DEFAULT_LOGIN.email && password === DEFAULT_LOGIN.password) {

            router.push("/");
            localStorage.setItem("xToken", DEFAULT_LOGIN.email)
          return
        }

        setErrorMessage('Email or Password not valid');

        // try {
        //   const variables = { email, password }
        //   const { data } = await login(variables);
        //   setLoading(true)

        //   if (data) {
        //       localStorage.setItem("token", data.login.token);
        //       localStorage.setItem("expiresAt", data.login.expires);
        //       localStorage.setItem("connectedTime", new Date().getTime());
        //       router.push("/");
        //   }
        //   setLoading(false)
        // } catch(error) {
        //   console.log('error: ', error);
        // }
    }

    const handleChange = event => {
        const { name, value } = event.target;
        if (name === 'email') setEmail(value);
        if (name === 'password') setPassword(value);
    }

    // const loadingButton = <CircularProgress className={classes.progress} size={20}/>

    return (
      <>
        { errorMessage  && <Typography variant="subtitle2" className={classes.error}>{errorMessage}</Typography>}
        <form className={classes.form} onSubmit={submit}>
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            id="email"
            label="Email Address"
            name="email"
            autoComplete="email"
            value={email}
            onChange={handleChange}
          />
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            name="password"
            label="Password"
            type="password"
            id="password"
            autoComplete="current-password"
            value={password}
            onChange={handleChange}
          />
          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            className={classes.submit}
            // disabled={loading}
          >
               Sign In
               {/* { loading ? loadingButton : 'Sign In'  } */}
          </Button>
        </form>
      </>
  );
}

export default LoginForm;